var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gc-grid-footer-css-v2"},[_c('div',{staticClass:"gc-grid-footer",attrs:{"id":"grid-footer"}},[(_vm.showLeftContainer)?_c('div',{staticClass:"gc-grid-footer-left"},[_vm._t("leftContent")],2):_vm._e(),(_vm.showRightContainer)?_c('div',{staticClass:"gc-grid-footer-right"},[_vm._t("rightContent")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }